const storageKey = "soma.localAuth.daytimePreview";

function isLocalPreviewEnabled(): boolean {
  return import.meta.env.DEV && import.meta.env.VITE_SOMA_LOCAL_AUTH === "true";
}

export function getLocalDaytimePreview(): boolean {
  return isLocalPreviewEnabled() && sessionStorage.getItem(storageKey) === "true";
}

export function storeLocalDaytimePreview(enabled: boolean) {
  if (isLocalPreviewEnabled() && enabled) {
    sessionStorage.setItem(storageKey, "true");
  } else {
    sessionStorage.removeItem(storageKey);
  }
}
